import React from 'react';
import { Tabs } from 'antd';
import { DollarOutlined, PercentageOutlined } from '@ant-design/icons';
import { Fees } from './Fees';
import LateFeePolicy from './LateFeePolicy';

/**
 * S11.3 — Consolidated Fee Management hub.
 * Combines "Fee Management" (Fees.tsx) and "Late Fee Policy" (LateFeePolicy.tsx)
 * into a single page with two tabs — both are admin-gated at the menu level.
 */
const FeeManagement: React.FC = () => {
  const items = [
    {
      key: 'fees',
      label: (
        <span>
          <DollarOutlined />
          &nbsp;Fee Management
        </span>
      ),
      children: <Fees />,
    },
    {
      key: 'late-fee-policy',
      label: (
        <span>
          <PercentageOutlined />
          &nbsp;Late Fee Policy
        </span>
      ),
      children: <LateFeePolicy />,
    },
  ];

  return (
    <Tabs
      items={items}
      size="large"
      destroyInactiveTabPane={false}
      style={{ marginTop: -8 }}
    />
  );
};

export default FeeManagement;
